/* 🤖 this file was generated by script */
export const wiconChevronLeftDouble = {
  name: 'chevron_left_double',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 17l-5-5 5-5m-7 10l-5-5 5-5"/></svg>`,
};
